import styled, { css } from 'styled-components'
import {
  BASE_Z_INDEX,
  defaultColorPalette,
  defaultTransitionTiming,
  MediaMaxS,
} from '@/5_shared/styles'
import {
  Input as InputUi,
  LabeledInput,
  LabeledInputWithCopy,
} from '@/5_shared/ui'

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 72px;
`

export const CurrenciesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 24px;
`

const blockStyles = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;
  align-items: stretch;
  margin-right: -24px;
`

export const AvailableBlock = styled.div`
  ${blockStyles}
`
export const NonAvailableBlock = styled.div`
  ${blockStyles};

  opacity: 0.5;
`

export const SelectCurrencyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  flex-basis: calc(33% - 24px);

  ${MediaMaxS`
    flex-basis: 100%;
  `}
`

export const SelectCurrencyTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: ${defaultColorPalette.darkTypeHigh};
`
export const TextBlock = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${defaultColorPalette.darkTypeHigh};
`

export const QrcodeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SelectCurrencyText = styled.div`
  color: ${defaultColorPalette.darkTypeMedium};
`

export const NonAvailableCurrencyWrapper = styled.div`
  flex-basis: calc(33% - 24px);
  height: 84px;

  ${MediaMaxS`
    flex-basis: calc(50% - 16px);
  `}
`

export const CurrencyCardWrapper = styled.div`
  flex-basis: calc(33% - 24px);

  ${MediaMaxS`
    flex-basis: calc(50% - 16px);
  `}
`

export const CurrencyStepHeadBlock = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: space-between;

  ${MediaMaxS`
    flex-direction: column;
  `}
`

export const CurrencyMainWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: space-between;
`

export const Labeled = styled(LabeledInput)`
  position: relative;
`

export const LabeledWithCopy = styled(LabeledInputWithCopy)`
  position: relative;
`

export const Input = styled(InputUi)``

export const CheckboxBlock = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: baseline;
  margin-bottom: 17.5px;
`

export const Checkbox = styled.input.attrs({
  type: 'checkbox',
})``

export const CheckboxLabel = styled.label<{ htmlFor: string }>`
  color: ${defaultColorPalette.darkTypeHigh};
  cursor: pointer;
`

export const CurrencyStepSelectCurrencyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  flex-basis: calc(50% - 12px);

  ${MediaMaxS`
    flex-basis: 100%;
  `}
`

export const CurrencyTabCurrencyCardWrapper = styled.div`
  flex-basis: calc(50% - 12px);

  ${MediaMaxS`
    flex-basis: 100%;
  `}
`

export const Dropdown = styled.div<{ $isShown: boolean }>`
  visibility: ${({ $isShown }) => ($isShown ? 'visible' : 'hidden')};
  opacity: ${({ $isShown }) => ($isShown ? 1 : 0)};
  position: absolute;
  z-index: ${BASE_Z_INDEX.DROPDOWN};
  top: 40px;
  left: 5px;
  right: 5px;
  background-color: ${defaultColorPalette.darkPrimary700};
  border-radius: 6px;
  padding-bottom: 6px;
  padding-top: 6px;
  transition: opacity ${defaultTransitionTiming.faster}s ease;
`

export const Option = styled.div<{ $isSelected: boolean }>`
  color: ${defaultColorPalette.white};
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  cursor: pointer;
  transition: background-color ${defaultTransitionTiming.fastest}s ease;
  user-select: none;

  background-color: ${({ $isSelected }) =>
    $isSelected
      ? defaultColorPalette.darkPrimary800
      : defaultColorPalette.darkPrimary700};

  &:hover {
    background-color: ${defaultColorPalette.white};
    color: ${defaultColorPalette.black};
  }

  &:active {
    background-color: ${defaultColorPalette.darkPrimary800};
  }
`
export const Select = styled.div`
  position: relative;
`
export const SelectedSystem = styled.div`
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1.5px ${defaultColorPalette.darkNeutrals400} solid;
  outline: none;
  background-color: transparent;
  color: ${defaultColorPalette.white};
  font-size: 16px;
  width: 100%;
  height: 42px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
`
export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 8px;
`
